var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',_vm._b({attrs:{"content-class":"floating-rounded-menu-container"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_vm._t("activator",null,null,{ on })]}}],null,true),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'v-menu',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }